import { TextArea, ThresholdPill } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { ITranslationEditItem, IValidationResult } from '../../../models';
import { Col3Col9, ColFull, Label, Section } from '../../common';
import { TranslationEditor } from '../../translations/TranslationEditor';

export interface IQuestionTextSectionProps {
	questionId?: number;
	textValue: string;
	translations: ITranslationEditItem[];
	validationResult?: IValidationResult;
	onChange: (textValue: string) => void;
	onTranslationChange: (translations: ITranslationEditItem[]) => void;
}

export const QuestionTextArea = styled(TextArea).attrs<{}>({
	className: 'tws-custom-question-textarea',
})`
	.tws-custom-question-textarea {
		height: 100px;
	}
`;

export const QuestionTextLimitDiv = styled.div`
	text-align: right;
	margin-top: 15px;
	display: inline-flex;
`;

export const QuestionTextThresholdPillContainer = styled.div`
	position: relative;
	top: -2px;
	margin-left: 5px;
	display: inline-flex;
`;

export const RightAlignDiv = styled.div`
	width: 100%;
	text-align: right;
`;

export const QuestionTranslationsText = styled('div')`
	margin-bottom: 5px;
`;

export const TranslationEditorWrapper = styled('div').attrs<{ hasText: boolean }>({
	className: 'tws-question-text-translations',
})<{ hasText: boolean }>`
	padding: ${(props) => (!props.hasText ? '25px 0;' : '0;')};
`;

export class QuestionTextSection extends React.Component<IQuestionTextSectionProps> {
	constructor(props: IQuestionTextSectionProps) {
		super(props);

		this.onChange = this.onChange.bind(this);
	}

	public render() {
		const { questionId, textValue, translations } = this.props;
		const errors = this.props.validationResult ? this.props.validationResult.errors : undefined;
		const showError = errors !== undefined && errors.length > 0;

		return (
			<Section id='add-custom-question' sectionHeader={ContentConstants.SECTIONHEADERS_CUSTOM_QUESTION_ADD}>
				<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_QUESTIONTEXT}>
					<RightAlignDiv>
						<QuestionTextArea
							id='questionText'
							placeholder={ContentConstants.INPUT_PLACEHOLDER_ENTER_QUESTION_TEXT}
							onChange={this.onChange}
							value={textValue}
							message={errors}
							error={showError}
							maxLength={1000}
						/>
						<QuestionTextLimitDiv>{ContentConstants.CUSTOM_QUESTION_RECOMMENDED_TEXT}</QuestionTextLimitDiv>
						<QuestionTextThresholdPillContainer>
							<ThresholdPill size='sm' count={textValue.trim().length} showThresholdCount={true} threshold={250} />
						</QuestionTextThresholdPillContainer>
					</RightAlignDiv>
				</Col3Col9>
				{translations.length > 0 && (
					<ColFull>
						<QuestionTranslationsText>
							<Label size='md'>{ContentConstants.SUBSECTIONHEADERS_QUESTIONTRANSLATIONS}</Label>
						</QuestionTranslationsText>
						<TranslationEditorWrapper hasText={textValue.trim().length > 0}>
							<TranslationEditor
								enableHtmlEditor={false}
								hasDefaultTranslation={textValue.trim().length > 0}
								property='CustomQuestionEditModel'
								propertyDisplayName={ContentConstants.TRANSLATIONS_QUESTION}
								onChange={this.props.onTranslationChange}
								translations={translations}
								showErrors={questionId !== undefined}
								maxLength={1000}
							/>
						</TranslationEditorWrapper>
					</ColFull>
				)}
			</Section>
		);
	}

	public onChange(e: any) {
		this.props.onChange(e.target.value);
	}
}
